import type { Me } from '../../modules/admin/types';

/**
 * Check if the current user has a given permission slug.
 * Use for UI visibility so the frontend matches backend route-permission rules.
 */
export function hasPermission(me: Me | null, slug: string): boolean {
  if (!me?.permission_slugs?.length) return false;
  return me.permission_slugs.includes(slug);
}

/**
 * Check if the current user has any of the given permission slugs.
 */
export function hasAnyPermission(me: Me | null, slugs: string[]): boolean {
  if (!me?.permission_slugs?.length || !slugs.length) return false;
  return slugs.some((s) => me.permission_slugs!.includes(s));
}
